define(function(require, exports, module) {
    'use strict';

    const _ = require('underscore');
    const BaseModel = require('common/base.model');
    const server = require('server');
    const user = require('user');
    const config = require('config');
    const $ = require('j');
    const getDynamicTagValue = require('../../util/swiss-theme/dynamicTag.value.util');

    module.exports = BaseModel.extend({

        bonusTypes: ['optIn', 'buyIn', 'free', 'deposit', 'campaign'],
        _bonusMetaInfo: {
            'FREE': { actionTitle: 'playtech.mobile.system.getFreeBonus', type: 'free' },
            'OPT_IN': { actionTitle: 'playtech.mobile.system.optIn', type: 'optIn' },
            'OPT_OUT': { actionTitle: 'playtech.mobile.system.optOut', type: 'optOut' },
            'BUY_IN': { actionTitle: 'playtech.mobile.system.buyIn', type: 'buyIn' },
            'FREE_SPINS': { actionTitle: 'playtech.mobile.system.freespin', type: 'freespin' },
            'DEPOSIT': { actionTitle: 'playtech.mobile.system.deposit', type: 'deposit' },
            'SIGN_UP': { actionTitle: 'playtech.mobile.system.login.button.join_now', type: 'join_now' },

            'LOGIN': { actionTitle: 'playtech.mobile.system.login.button.login', type: 'login' },
            'GOLDEN_CHIPS': { actionTitle: 'playtech.mobile.system.goldenChips', type: 'goldenChips' },
            'CUSTOM': { actionTitle: '', type: 'custom' },
            'CAMPAIGN': { actionTitle: '', type: 'campaign' }
        },
        bonusTriggers: ['SIGN_UP', 'FREE_SPINS', 'CUSTOM', 'GOLDEN_CHIPS', 'CAMPAIGN'],

        initialize: function(options) {
            this.options = options;
            this.bonusesConfig = config.get('bonusesConfiguration') || [];
            this.bonusesPrefs = config.get('bonusManagementPreferences');
            this._addBonusTypes();

            const dynamicTag = getDynamicTagValue('BONUS_MULTIVIEW_COUNTER_SETTING');

            try{
                const parsedTag = JSON?.parse(dynamicTag);
                this.bonusMultiviewCounterSetting = parsedTag;
                const bonusList = [];

                parsedTag.forEach(el => {
                    const map = el.bonuses.map(e => e.bonusCode);
                    bonusList.push(map);
                });

                this.bonusCodes = bonusList.flat();
            } catch (e) {
                console.warn(e, 'Please, check Dynamic Tag {DTAG_BONUS_MULTIVIEW_COUNTER_SETTING}');
            }

        },

        _addBonusTypes: function() {
            _.each(this.bonusesConfig, function(bonus) {
                const { bonusCode, bonusTrigger } = bonus;

                _.extend(bonus, this._bonusMetaInfo[bonusTrigger]);

                if (bonusTrigger === 'CUSTOM' || bonusTrigger === 'CAMPAIGN') {
                    const bonusType = bonusTrigger === 'CUSTOM' ? 'custombonus' : 'campaignbonus';

                    bonus.actionTitle = user.isLoggedIn()
                        ? `playtech.mobile.system.bonus.${bonusCode}.${bonusType}.logged-in`
                        : `playtech.mobile.system.bonus.${bonusCode}.${bonusType}.logged-out`;
                }
            }, this);
        },

        parse: function(response, options) {
            const filteredBonusesConfig = this.getFilteredBonusesConfig();
            const savedOrder = filteredBonusesConfig.map(function(bonus) { return bonus.bonusCode; });
            let result;

            if (user.isLoggedIn()) {
                result = this._mergeBonusesWithConfig(response.data.matchingBonusTemplates, filteredBonusesConfig);

                this._setOptOutBonuses(result, response.optInList);
                this._addConfigBonuses(result, filteredBonusesConfig);
            } else {
                result = filteredBonusesConfig;
                this._changeButtonsToLogin(result);
            }
            options.parse = false;
            this._filterByExistOrder(result, savedOrder);

            return result;
        },

        _setOptOutBonuses: function(bonuses, optInList) {
            let bonus;
            _.each(optInList, function(optInInfo) {
                bonus = _.findWhere(bonuses, { bonusCode: optInInfo.templateCode });
                if (bonus) {
                    bonus.bonusTrigger = 'OPT_OUT';
                    _.extend(bonus, this._bonusMetaInfo[bonus.bonusTrigger]);
                }
            }.bind(this));
        },

        _addConfigBonuses: function(bonuses, bonusesCfg) {
            bonusesCfg.forEach(function(bonus) {
                if (bonus.bonusTrigger === 'FREE_SPINS'
                    || bonus.bonusTrigger === 'CUSTOM'
                    || bonus.bonusTrigger === 'GOLDEN_CHIPS'
                    && !_.findWhere(bonuses, { bonusCode: bonus.bonusCode })) {

                    bonuses.push(bonus);
                }
            });
        },

        _filterByExistOrder: function(bonuses, order) {
            const move = function(array, from, to) {
                const element = array[from];
                array.splice(from, 1);
                array.splice(to, 0, element);
            };

            order.forEach(function(code, index) {
                const position = _.findIndex(bonuses, function(bonus) {
                    return bonus.bonusCode === code;
                });
                if (position !== -1) {
                    move(bonuses, position, index);
                }
            });
        },

        sync: function(method, model, options) {
            if (method !== 'read') {
                return;
            }

            const filteredBonusesConfigs = this.getFilteredBonusesConfig();
            let bonusTypes;
            bonusTypes = this._getBonusTypes(filteredBonusesConfigs);

            const request = {
                ID: 31143,
                responses: [31144, 31145],
                description: 'Search Player Available Bonus Templates (from bonus counter)',
                triggerTypes: []
            };
            const promoCodes = [];

            bonusTypes.forEach(function(bonusType) {
                switch (bonusType) {
                    case 'free':
                        if (this.bonusesPrefs.bonusFreeCode && this.bonusesPrefs.bonusFreeCode.trim()) {
                            promoCodes.push(this.bonusesPrefs.bonusFreeCode);
                        }
                        break;
                    case 'optIn':
                        if (this.bonusesPrefs.bonusOptInCode && this.bonusesPrefs.bonusOptInCode.trim()) {
                            promoCodes.push(this.bonusesPrefs.bonusOptInCode);
                        }
                        break;
                    case 'buyIn':
                        request.triggerTypes.push('buybonus');
                        break;
                    case 'deposit':
                        request.triggerTypes.push('deposit');
                        break;
                    case 'campaign':
                        request.triggerTypes.push('campaign');
                        break;
                }
            }.bind(this));

            if (promoCodes.length) {
                request.triggerTypes.push('promotioncode');

                if (promoCodes.length > 1) {
                    return $.when(
                        server.send({ ...request, promotionCode: promoCodes[0] }),
                        server.send({ ...request, promotionCode: promoCodes[1] })
                    );
                }

                return server.send(_.extend(request, { promotionCode: promoCodes[0] }));
            }

            return server.send(request).then(options.success, options.error);
        },

        _filterByPresentation: function(bonus) {
            return _.contains(this.bonusCodes, bonus.bonusCode);
        },

        _filterByUserSegmentation: function(bonus) {
            const filterByLoggedIn = bonus.showFor === 'BOTH' || user.isLoggedIn() !== (bonus.showFor === 'LOGGED_OUT');
            const filterBySignUp = !(user.get('hasBeenLoggedIn') && bonus.bonusTrigger === 'SIGN_UP');

            return filterByLoggedIn && filterBySignUp;
        },

        _mergeBonusesWithConfig: function(bonuses, bonusesConfig) {
            let bonusCfg;
            return bonuses.filter(function(bonus) {
                bonusCfg = _.findWhere(bonusesConfig, { bonusCode: bonus.code });
                if (bonusCfg) {
                    _.extend(bonus, _.omit(bonusCfg, 'code'));
                    return true;
                }
                return false;
            });
        },

        _getBonusTypes: function(bonusesCfg) {
            return _.filter(this.bonusTypes, function(type) {
                return _.findWhere(bonusesCfg, { type: type });
            });
        },

        getFilteredBonusesConfig: function() {
            if (user.isAdmin()) {
                return this.bonusesConfig;
            }

            return _.filter(this.bonusesConfig, function(bonus) {
                return this._filterByUserSegmentation(bonus) && this._filterByPresentation(bonus);
            }.bind(this));
        },
    });
});
